<template>
  <div
    class="content-wrapper word-cloud-content-v2"
  >
    <WordCloudV2 v-if="!slideActive.showQuestionImage && !slideActive.hideResult" />
    <CanvasQuestionImage
      v-show="slideActive.showQuestionImage && slideActive.image"
      @imageLoaded="isLoading = false"
      :isLoading="isLoading"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'
import Util from '@/util'
import WordCloudV2 from './WordCloudV2.js'

export default {
  components: {
    CanvasQuestionImage,
    WordCloudV2,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),

    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
  },

  mounted() {
    if (this.$store.state.sharePresentation) {
      this.updateSlideActiveAction({
        showQuestionImage: false,
      })
    }
  },
  destroyed() {
    Util.allowPDFRender()
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    checkShowContent() {
      let show = true
      if (this.$store.state.slideActive.showQuestionImage && this.$store.state.slideActive.image) {
        show = false
      } else if (!this.$store.state.slideActive.hideResult) {
        show = true
      } else {
        show = false
      }
      return show
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.content-wrapper {
  width: 100%;
  height: 100%;
  // &.cross-content {
  //   &::v-deep text:hover {
  //     text-decoration: line-through;
  //     cursor: pointer;
  //   }
  // }
}
</style>
